// extracted by mini-css-extract-plugin
export default {"container":"ToggleBtnsComponent_container__vOCQ2"};